export enum ReceiverType {
  General = 'GENERAL',
  Customer = 'CUSTOMER'
}
